import {
  Component,
  ComponentRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  forwardRef,
} from '@angular/core';
import {
  FormControl,
  FormControlStatus,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { IFormControlConfig } from '../eo-base-form-control/eo-base-form-control.model';
import { EoFormPanelConfig } from './eo-form-panel.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'eo-form-panel',
  templateUrl: './eo-form-panel.component.html',
  styleUrl: './eo-form-panel.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoFormPanelComponent),
      multi: true,
    },
  ],
})
export class EoFormPanelComponent implements OnInit {
  @ViewChild('dynamicComponentContainer', {
    read: ViewContainerRef,
    static: true,
  })
  container!: ViewContainerRef;

  private subscriptions: Subscription[] = [];
  private previousStatus?: FormControlStatus;
  @Input() customFormControls: { [key: string]: TemplateRef<any> | null } = {};

  private _config?: EoFormPanelConfig;
  @Input() set config(val: EoFormPanelConfig) {
    this._config = val;
    // this.container?.clear();

    // this._config.config.forEach((config) => {
    //   this.container?.createComponent(config.component);
    // });
    // You can pass data to the dynamically loaded
  }
  get config(): EoFormPanelConfig | undefined {
    return this._config;
  }
  @Input() header?: string;
  @Input() headerIcon?: string;
  @Input() headerStyleClass?: string;
  @Input() styleClass?: string;
  @Input() panelContentStyleClass?: string;
  @Input() formGroup!: FormGroup;
  @Output() statusChange = new EventEmitter<FormControlStatus>();
  defaultHeaderStyleClass = 'text-lg font-semibold';

  constructor() {}

  ngOnInit(): void {
    this.subscriptions = [];
  }

  ngAfterViewInit() {
    // this._config?.config.forEach((config) => {
    //   this.container.createComponent(config.component);
    // });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscriptions.forEach((s) => s?.unsubscribe());
  }

  onStatusChange() {
    this.formGroup.updateValueAndValidity();
  }

  protected getFormType(item: IFormControlConfig): string {
    switch (item.type) {
      case 'custom':
        return 'custom';
      case 'dropdown':
      case 'countryDropdown':
      case 'specialtyDropdown':
      case 'checkbox':
      case 'radioButton':
      case 'datepicker':
        case 'textarea':
        return item.type;
      default:
        return 'input';
    }
  }
  protected getFormControl(formControlName: string): FormControl<any> {
    if (!this.formGroup.get(formControlName)) return new FormControl();
    return this.formGroup.get(formControlName) as FormControl;
  }
  protected getConfig(): EoFormPanelConfig | undefined {
    return this.config;
  }
  protected getFormGroup(): FormGroup {
    return this.formGroup;
  }
  protected getHeader(): string | undefined {
    return this.header ?? this.config?.header;
  }
  protected getHeaderStyleClass(): string | undefined {
    return `${this.defaultHeaderStyleClass} ${
      this.headerStyleClass ?? this.config?.headerStyleClass
    }`;
  }
  protected getHeaderIcon(): string | undefined {
    return this.headerIcon ?? this.config?.headerIcon;
  }
  protected getStyleClass(): string | undefined {
    return this.styleClass ?? this.config?.styleClass;
  }
  protected getPanelContentStyleClass(): string | undefined {
    return this.panelContentStyleClass ?? this.config?.panelContentStyleClass;
  }

  writeValue(obj: any): void {}
  registerOnChange(fn: any): void {}
  registerOnTouched(fn: any): void {}
}
